<div class="min-h-screen flex flex-col"
	style="background-image: url('/images/marble_texture.png'); background-size: cover; background-position: center;">

	<img src="/images/marbleBorder.png" alt="" style="width: 100%; height: 20px; display: block; object-fit: cover; flex-shrink:0;" />

	<div class="flex flex-1 items-start justify-center px-8 py-10">
		<div class="w-full" style="max-width: 780px;">

			<div class="mb-8 text-center">
				<h1 style="font-family: var(--font-family-display); font-size: 1.5rem; font-weight: 600; letter-spacing: 0.12em; color: var(--color-aegean-700);">
					<span ro-i18n eikey="login.brandName">The Socrates Initiative</span>
				</h1>
				<div style="width: 60px; border-top: 1px solid var(--color-gold-500); margin: 8px auto;"></div>
			</div>

			<div class="rounded-lg shadow-2xl overflow-hidden"
				style="border: 6px solid var(--color-sandstone); outline: 1px solid var(--color-gold-500);">

				<img src="/images/marbleBorder.png" alt="" style="width: 100%; height: 20px; display: block; object-fit: cover;" />

				<div style="background-image: url('/images/marble_texture.png'); background-size: cover; padding: 40px 50px 40px;">

					<h2 class="mb-1 text-2xl font-semibold" style="color: var(--color-charcoal); font-family: var(--font-family-display); letter-spacing: 0.03em;">
						<span ro-i18n eikey="legal.tos.title">Terms of Service</span>
					</h2>
					<p class="mb-6 text-xs opacity-60" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
						{{ getMessage('legal.tos.lastUpdated').replace('{date}', today) }}
					</p>

					@for (section of sections; track section) {
						<div class="mb-6">
							<h3 class="mb-2 text-sm font-semibold" style="color: var(--color-aegean-700); font-family: var(--font-family-display);">
								{{ getMessage('legal.tos.' + section + '.heading') }}
							</h3>
							<p class="text-sm leading-relaxed" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
								{{ getMessage('legal.tos.' + section + '.body') }}
							</p>
						</div>
					}

					<div class="mt-8 pt-6" style="border-top: 1px solid var(--color-sandstone);">
						<p class="text-xs leading-relaxed mb-6" style="color: var(--color-charcoal); font-family: var(--font-family-ui); opacity: 0.8;">
							<span ro-i18n eikey="legal.tos.effectiveNotice">By creating an account, you agree to these Terms of Service and the Community Guidelines above.</span>
						</p>
						<a href="javascript:window.close()"
							class="text-sm underline"
							style="color: var(--color-aegean-600); font-family: var(--font-family-ui);">
							← Back to sign up
						</a>
					</div>

				</div>

				<img src="/images/marbleBorder.png" alt="" style="width: 100%; height: 20px; display: block; object-fit: cover;" />
			</div>

		</div>
	</div>

	<img src="/images/marbleBorder.png" alt="" style="width: 100%; height: 20px; display: block; object-fit: cover; flex-shrink:0;" />
</div>
